import React from "react";

import Table from "./Table";

function body(props) {
  return (
    <div className="main_container_body">
      <div className="main_container_body__inner">
        <Table
          dates={props.dates}
          showScrollTop={props.showScrollTop}
          enterDates={props.enterDates}
        />
      </div>
    </div>
  );
}

export default body;
